import DragCardGame from './DragCardGame';

export default DragCardGame;
